// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__FUCVc","signatureBlock":"Footer_signatureBlock__26ARc","signature":"Footer_signature__2vrkt"};